var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['backing', _vm.backgroundStyle]},[_c('font-awesome-icon',{staticClass:"pi-icon",attrs:{"icon":"fa-solid fa-circle-user"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }